import React from "react";
import {
  Redirect,
  Switch,
  Route,
  BrowserRouter,
  useHistory,
  useRouteMatch,
} from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import "./App.css";

import { Home } from "./Home/Home";
import { About } from "./About/About";
import { MEPDetails } from "./Details/MEP";
import { GroupDetails } from "./Details/Group";
import { CountryDetails } from "./Details/Country";

const HomeAppBarComponent = () => {
  const history = useHistory();

  return (
    <Grid container justify="flex-end">
      <Button
        size="small"
        variant="contained"
        href="mailto:nextgenerationdemocracy@gmail.com"
      >
        Feedback
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        size="small"
        color="secondary"
        variant="contained"
        onClick={() => {
          history.push("/about");
        }}
      >
        About
      </Button>
    </Grid>
  );
};

function GoBackComponent() {
  const match = useRouteMatch();

  return (
    <IconButton
      onClick={() => {
        window.history.back();
      }}
    >
      <KeyboardBackspaceIcon />
    </IconButton>
  );
}

export const App = () => {
  return (
    <>
      <BrowserRouter>
        <AppBar position="sticky">
          <Toolbar>
            <Switch>
              <Route path="/about" exact component={GoBackComponent} />
              <Route path="/mep/:id" component={GoBackComponent} />
              <Route path="/group/:id" component={GoBackComponent} />
              <Route path="/country/:id" component={GoBackComponent} />
              <Route path="/mep" exact component={HomeAppBarComponent} />
              <Route path="/country" exact component={HomeAppBarComponent} />
              <Route path="/group" exact component={HomeAppBarComponent} />
            </Switch>
          </Toolbar>
        </AppBar>
        <Switch>
          <Route path="/about" component={About} exact />
          <Route path="/mep/:id" exact component={MEPDetails} />
          <Route path="/country/:id" exact component={CountryDetails} />
          <Route path="/group/:id" exact component={GroupDetails} />
          <Route path="/:id" component={Home} />
          <Redirect to="/mep" />
        </Switch>
      </BrowserRouter>
    </>
  );
};
